import { render, staticRenderFns } from "./StartupDocumentsInfo.vue?vue&type=template&id=106cfd27&scoped=true&"
import script from "./StartupDocumentsInfo.vue?vue&type=script&lang=js&"
export * from "./StartupDocumentsInfo.vue?vue&type=script&lang=js&"
import style0 from "./StartupDocumentsInfo.vue?vue&type=style&index=0&id=106cfd27&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "106cfd27",
  null
  
)

export default component.exports